import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import './index.scss';
import http from '../../utils/request'

class Footer extends Component {

  state = {
    title: '',
    address: [],
    contact: '',
    menu: []
  }

  componentDidMount() {
    http('post', '/achieve/circle/foot').then(res => {
      if (res.code === 200) {
        const { about, address, contact, menu } = res.data
        this.setState({
          title: about,
          address,
          contact,
          menu
        })
      }
    })
  }

  handleMenu = (e) => {
    const pathItem = e.currentTarget.dataset.pathname;
    let allCategory = document.querySelectorAll('.pc-header__item');
    allCategory.forEach(item => {
      if (pathItem === item.dataset.jsItem) {
        item.className = "pc-header__item active"
      } else {
        item.className = "pc-header__item"
      }
    })
  }

  render() {
    const { title, address, contact, menu } = this.state;
    return (
      <Fragment>
        <div className="footer">
          <div className="footer__menu">
            <ul className="footer__cta">
              <li className="footer__cta--item">
                <img className="f-logo" src="https://achieve.obs.cn-southwest-2.myhuaweicloud.com/achieve/img/white.svg" alt="" />
              </li>
              <li className="footer__cta--item">
                <p className="title">
                  <Link to={title ? title.path : '#'} onClick={e => this.handleMenu(e)} data-pathname={title.path}>{title ? title.title : '关于我们'}</Link>
                </p>
                <ul className="footer__cta--group">
                  {
                    menu.length > 0 && (
                      menu.map(item => {
                        return (
                          <li key={item.path} className="footer__cta--list-item">
                            <Link to={item.path} className="link" onClick={e => this.handleMenu(e)} data-pathname={item.path}>{item.title}</Link>
                          </li>
                        )
                      })
                    )
                  }
                </ul>
              </li>
              <li className="footer__cta--item">
                <p className="title">联系方式</p>
                <ul className="footer__cta--group">
                  {
                    contact ? (
                      <li className="footer__cta--list-item">
                        <p className="link">{contact.tel}</p>
                      </li>
                    ) : null
                  }
                  {
                    contact ? (
                      <li className="footer__cta--list-item">
                        <p className="link">{contact.phone}</p>
                      </li>
                    ) : null
                  }
                  {
                    contact ? (
                      <li className="footer__cta--list-item">
                        <p className="link"><span>邮箱：</span>{contact.email}</p>
                        <p className="link"><span></span>{contact.email2}</p>
                      </li>
                    ) : null
                  }
                </ul>
              </li>
              <li className="footer__cta--item">
                <p className="title">地址</p>
                <ul className="footer__cta--group">
                  {
                    address.length > 0 ? (
                      <li className="footer__cta--list-item">
                        <p className="link">{address[0]}{address[1]}</p>
                      </li>
                    ) : (
                      <li className="footer__cta--list-item">
                        <p className="link">成都市高新区环球中心S2区6栋1103/1104/1105号</p>
                      </li>
                    )
                  }
                </ul>
              </li>
            </ul>
          </div>

          <div className="footer__copy-right">
            <p className="desc">Copyright © 2019-2021 医创汇-国际医疗创新服务平台. All rights reserved   蜀ICP备19011649号-1</p>
          </div>
        </div>
      </Fragment>
    )
  }
}

export default connect(null, null)(Footer);